import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["totalResults", "selectedFilters", "onFilterApply", "showResetInFilterDialog", "showFilterTrigger", "showResultsCount", "showReset", "showDefaultFilter", "className", "filterTypes", "saveDefaultFilters", "isFilterLabelStacked", "showClear", "defaultFilterContainerClassname", "showSortTrigger", "renderResultsLabel"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import _noop from 'lodash/noop';
import cx from 'classnames';
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { DEFAULT_FILTER_BEHAVIOR, FILTER_TOOL_BAR_TEXTUAL_ACTIONS } from '../../constants/filterSection.constants';

// Constants
import { DEFAULT_FILTER_GROUP } from '../../constants/filterSection.filterGroups';

// Components
import FilterTrigger from '../filterTrigger';
import FilterResults from '../../atoms/filterResults';
import FilterDialog from '../../filterDialog';
import FiltersList from './filtersList';
import TextualAction from '../../atoms/textualAction';
import MultiSortTrigger from '../../../MultiSort/components/MultiSortTrigger';
import PropertyControlledComponent from '../../../../molecules/PropertyControlledComponent';

// Helpers
import { getDefaultFilterTypes } from '../../helpers/filterSection.defaultFilter';
import { fireDefaultFilterChangeClickStreamEvent, isFilterOfSelectType } from './defaultFilterToolbar.helpers';

// Styles
import s from './defaultFilterToolbar.module.scss';
var DefaultFilterToolbar = /*#__PURE__*/function (_Component) {
  _inherits(DefaultFilterToolbar, _Component);
  var _super = _createSuper(DefaultFilterToolbar);
  function DefaultFilterToolbar() {
    var _this;
    _classCallCheck(this, DefaultFilterToolbar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getVisibleFilterTypes", defaultMemoize(function (defaultFilterTypeIds, filterTypes) {
      var defaultFilters = getDefaultFilterTypes(defaultFilterTypeIds, filterTypes);
      var visibleDefaultFilters = _filter(defaultFilters, isFilterOfSelectType);
      return visibleDefaultFilters;
    }));
    _defineProperty(_assertThisInitialized(_this), "getFilterValues", function () {
      var _this$props = _this.props,
        selectedFilterGroup = _this$props.selectedFilterGroup,
        defaultFilterBehavior = _this$props.defaultFilterBehavior,
        defaultFilterValues = _this$props.defaultFilterValues,
        shouldSetDefaultFilter = _this$props.shouldSetDefaultFilter;
      var shouldSetDefaultFilterValues = selectedFilterGroup === DEFAULT_FILTER_GROUP && (defaultFilterBehavior === DEFAULT_FILTER_BEHAVIOR.PERSIST_LOCAL || shouldSetDefaultFilter);
      return shouldSetDefaultFilterValues ? defaultFilterValues : EMPTY_ARRAY;
    });
    _defineProperty(_assertThisInitialized(_this), "handleReset", function () {
      var _this$props2 = _this.props,
        onFilterApply = _this$props2.onFilterApply,
        saveDefaultFilters = _this$props2.saveDefaultFilters,
        selectedFilterGroup = _this$props2.selectedFilterGroup;
      var filterValues = _this.getFilterValues();
      saveDefaultFilters(filterValues);
      onFilterApply(filterValues, selectedFilterGroup, {
        actionType: FILTER_TOOL_BAR_TEXTUAL_ACTIONS.RESET
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      var _this$props3 = _this.props,
        onFilterApply = _this$props3.onFilterApply,
        saveDefaultFilters = _this$props3.saveDefaultFilters,
        selectedFilterGroup = _this$props3.selectedFilterGroup;
      var filterValues = _this.getFilterValues();
      saveDefaultFilters(filterValues);
      onFilterApply(filterValues, selectedFilterGroup, {
        actionType: FILTER_TOOL_BAR_TEXTUAL_ACTIONS.CLEAR
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderSortButton", function () {
      var _this$props4 = _this.props,
        onSortApply = _this$props4.onSortApply,
        columns = _this$props4.columns,
        sortDetails = _this$props4.sortDetails,
        assetType = _this$props4.assetType,
        applyInitSort = _this$props4.applyInitSort,
        showFilterTrigger = _this$props4.showFilterTrigger,
        allColumns = _this$props4.allColumns;
      return /*#__PURE__*/React.createElement(MultiSortTrigger, {
        applyInitSort: applyInitSort,
        allColumns: allColumns,
        columns: columns,
        sortDetails: sortDetails,
        onSortApply: onSortApply,
        assetType: assetType,
        classNames: cx(_defineProperty({}, s.clearLeftMargin, !showFilterTrigger))
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDefaultFilterApply", function (filters, selectedFilterGroup) {
      var additional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
      var _this$props5 = _this.props,
        onFilterApply = _this$props5.onFilterApply,
        module = _this$props5.module;
      fireDefaultFilterChangeClickStreamEvent({
        module: module
      });
      onFilterApply(filters, selectedFilterGroup, _objectSpread(_objectSpread({}, additional), {}, {
        isDefaultFilterModified: true
      }));
    });
    return _this;
  }
  _createClass(DefaultFilterToolbar, [{
    key: "getFiltersTypes",
    value: function getFiltersTypes() {
      var _this$props6 = this.props,
        filterTypes = _this$props6.filterTypes,
        defaultFilterTypes = _this$props6.defaultFilterTypes;
      var visibleFilterTypes = this.getVisibleFilterTypes(defaultFilterTypes, filterTypes);
      return visibleFilterTypes;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        totalResults = _this$props7.totalResults,
        selectedFilters = _this$props7.selectedFilters,
        onFilterApply = _this$props7.onFilterApply,
        showResetInFilterDialog = _this$props7.showResetInFilterDialog,
        showFilterTrigger = _this$props7.showFilterTrigger,
        showResultsCount = _this$props7.showResultsCount,
        showReset = _this$props7.showReset,
        showDefaultFilter = _this$props7.showDefaultFilter,
        className = _this$props7.className,
        filterTypes = _this$props7.filterTypes,
        saveDefaultFilters = _this$props7.saveDefaultFilters,
        isFilterLabelStacked = _this$props7.isFilterLabelStacked,
        showClear = _this$props7.showClear,
        defaultFilterContainerClassname = _this$props7.defaultFilterContainerClassname,
        showSortTrigger = _this$props7.showSortTrigger,
        renderResultsLabel = _this$props7.renderResultsLabel,
        filterDialogProps = _objectWithoutProperties(_this$props7, _excluded);
      var visibleFilterTypes = this.getFiltersTypes();
      var visibleFilterTypesPresent = !_isEmpty(visibleFilterTypes);
      return /*#__PURE__*/React.createElement("div", {
        className: s.container
      }, showFilterTrigger && /*#__PURE__*/React.createElement(FilterTrigger, _extends({}, filterDialogProps, {
        filterTypes: filterTypes,
        showReset: showReset || showResetInFilterDialog,
        selectedFilters: selectedFilters,
        onFilterApply: onFilterApply
      })), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: showSortTrigger
      }, this.renderSortButton()), visibleFilterTypesPresent && /*#__PURE__*/React.createElement(Fragment, null, showDefaultFilter && /*#__PURE__*/React.createElement(FiltersList, {
        filterTypes: visibleFilterTypes,
        selectedFilters: selectedFilters,
        isFilterLabelStacked: isFilterLabelStacked,
        onFilterApply: this.handleDefaultFilterApply,
        showFilterTrigger: showFilterTrigger,
        saveDefaultFilters: saveDefaultFilters,
        filterContainerClassname: defaultFilterContainerClassname
      }), showReset && /*#__PURE__*/React.createElement(TextualAction, {
        label: __('Reset'),
        className: s.reset,
        onClick: this.handleReset
      }), showClear && /*#__PURE__*/React.createElement(TextualAction, {
        label: __('Clear'),
        className: s.clear,
        onClick: this.handleClear
      })), showResultsCount && /*#__PURE__*/React.createElement(FilterResults, {
        resultsCount: totalResults,
        className: className,
        renderResultsLabel: renderResultsLabel
      }));
    }
  }]);
  return DefaultFilterToolbar;
}(Component);
DefaultFilterToolbar.propTypes = _objectSpread(_objectSpread({}, FilterDialog.propTypes), {}, {
  totalResults: PropTypes.number,
  shouldSetDefaultFilter: PropTypes.bool,
  showFilterTrigger: PropTypes.bool,
  showResultsCount: PropTypes.bool,
  showReset: PropTypes.bool,
  saveDefaultFilters: PropTypes.func,
  showClear: PropTypes.bool,
  showDefaultFilter: PropTypes.bool,
  defaultFilterContainerClassname: PropTypes.string,
  showSortTrigger: PropTypes.bool,
  renderResultsLabel: PropTypes.func,
  showResetInFilterDialog: PropTypes.bool
});
DefaultFilterToolbar.defaultProps = _objectSpread(_objectSpread({}, FilterDialog.defaultProps), {}, {
  totalResults: 0,
  shouldSetDefaultFilter: false,
  showFilterTrigger: true,
  showResultsCount: true,
  showReset: true,
  showClear: false,
  showDefaultFilter: true,
  saveDefaultFilters: _noop,
  defaultFilterContainerClassname: EMPTY_STRING,
  showSortTrigger: false,
  renderResultsLabel: undefined,
  showResetInFilterDialog: false
});
export default DefaultFilterToolbar;